import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { PAGE_SIZE_OPTIONS, STORE_EXCHANGE_LABELS } from "../types";

interface StoreExchangePageSizeSelectProps {
  readonly value: number;
  readonly onChange: (value: number) => void;
}

export function StoreExchangePageSizeSelect({
  value,
  onChange,
}: StoreExchangePageSizeSelectProps) {
  return (
    <div className="flex items-center gap-2 text-xs text-slate-600">
      <span>{STORE_EXCHANGE_LABELS.pageSizeLabel}</span>
      <Select
        value={String(value)}
        onValueChange={next => onChange(Number(next))}
      >
        <SelectTrigger className="h-8 w-[72px] bg-white text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PAGE_SIZE_OPTIONS.map((option: number) => (
            <SelectItem key={option} value={String(option)} className="text-xs">
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
